import api from "@/utils/axios";

// GET all module audiences
export const getAllModuleAudiences = () =>
    api.get("api/module-audience");

// GET module audience by id
export const getModuleAudienceById = (id) =>
    api.get(`api/module-audience/${id}`);

// CREATE module audience
export const createModuleAudience = (payload) =>
    api.post("api/module-audience", payload);

// UPDATE module audience
export const updateModuleAudience = (id, payload) =>
    api.put(`api/module-audience/${id}`, payload);

// DELETE module audience
export const deleteModuleAudience = (id) =>
    api.delete(`api/module-audience/${id}`);
